export default function AboutContact() {
  return (
    <div className="min-h-screen bg-[#e8ecf7] py-8 px-4">
      <div className="max-w-3xl mx-auto bg-white/80 border border-[#e3d5dd] rounded-2xl shadow-md p-6 md:p-10">
        
        <h1 className="text-2xl md:text-3xl font-semibold text-[#8e3e3e] mb-4 text-center">
          About Swift-Lore
        </h1>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-4">
          <strong>Swift-Lore</strong> is an independent, fan-created research archive 
          documenting Taylor Swift’s complete career history—from her earliest 
          performances in the early 2000s to the present day.
        </p>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-4">
          Our goal is to provide the most accurate, structured, and searchable 
          timeline possible, featuring:
        </p>

        <ul className="list-disc pl-6 text-[#4b4b63] text-sm md:text-base leading-relaxed mb-4">
          <li>Verified event dates across all years and eras</li>
          <li>Context notes, source links, and references</li>
          <li>Album, era, and keyword classification</li>
          <li>Historical analysis & documentation</li>
          <li>Fan research compiled into an easy-to-navigate archive</li>
        </ul>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-6">
          Swift-Lore is continuously updated and maintained as a passion project 
          by a dedicated fan for the purpose of research, education, and historical 
          preservation.
        </p>

        <h2 className="text-xl font-semibold text-[#8e3e3e] mt-8 mb-3">
          Non-Affiliation Disclaimer
        </h2>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-4">
          Swift-Lore is an independent fan-run project and is 
          <strong> not affiliated with, endorsed by, or connected to Taylor Swift, Taylor 
          Nation, TAS Rights Management, Republic Records, Big Machine Records, or 
          any official entity.</strong>
        </p>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-6">
          All content is presented for research, commentary, and archival 
          purposes under fair-use guidelines.
        </p>

        <h2 className="text-xl font-semibold text-[#8e3e3e] mt-8 mb-3">
          Contact
        </h2>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-2">
          For corrections, submissions, questions, collaborations, or press inquiries:
        </p>

        <p className="text-[#8e3e3e] font-semibold text-sm md:text-base mb-6">
          ✉️ Email: <a href="mailto:info@swift-lore.com" className="underline">
            info@swift-lore.com
          </a>
        </p>

        <p className="text-[#4b4b63] text-sm md:text-base leading-relaxed mb-6">
          You can also submit event corrections or suggestions using our 
          Google Form by clicking Submit a Suggestion at the bottom of the page.
        </p>

        {/* ⭐ CONTENT DISCLAIMER (required by AdSense) */}
        <div className="text-[10px] text-[#6b7db3] leading-tight mt-8">
          All event dates and information are collected from publicly available sources.
          Swift-Lore is a fan-created research project and may contain occasional inaccuracies.
          If you spot an error, please contact us.
        </div>

        <div className="text-center mt-10 text-xs text-[#6b7db3]">
          Swift-Lore © 2025 — Fan-made, educational, research-focused.
        </div>

      </div>
    </div>
  );
}
